export class FilterDivisions {
    description!: string;
}